import React from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory, useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Box,
  Typography,
  useTheme,
  Container,
  Grid,
  MenuItem,
  useMediaQuery,
  Select,
  FormControl,
  FormHelperText,
  TextField,
  TextareaAutosize,
  Divider,
} from "@material-ui/core";
import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";

import VerificationCode from "./VerificationCode";
import { useAlert } from "../components/Alert";
import LoadingModal from "../components/LoadingModal";

const SAVE_CUSTOMER = gql`
  mutation saveCustomer($customerInput: CustomerInput!) {
    saveCustomer(customerInput: $customerInput)
  }
`;

export default function InvestmentPage() {
  const theme = useTheme();
  return (
    <Box
      style={{
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <InvestmentText />
      <Divider
        variant="middle"
        style={{
          backgroundColor: theme.palette.secondary.light,
          height: "2px",
          width: "80%",
        }}
      />
      <InvestmentForm />
    </Box>
  );
}

function InvestmentText() {
  const theme = useTheme();
  const useStyles = makeStyles((theme) => ({
    gridbox: {
      marginBottom: "50px",
      "& .MuiTypography-h4": {
        fontWeight: 700,
        marginBottom: "50px",
      },
    },
  }));
  const classes = useStyles();
  const ruleList = [
    "01‧產權調查不清",
    "02‧價格評估錯誤",
    "03‧屋況無法確保",
    "04‧無法交屋之危險",
    "05‧違法-被告之危險",
    "06‧海蟑螂惡意占有",
    "07‧債務人賴皮不走",
    "08‧黑道或遇到抗爭",
    "09‧不諳點交程序流程",
    "10‧協調不易或方法錯誤",
    "11‧缺乏專業的法拍顧問",
    "12‧拍賣公告解讀有誤",
    "13‧沒有經營智囊團隊協助",
    "14‧道聽塗說拿血汗錢開玩笑",
    "15‧留下祖先牌位",
    "16‧留下眾多神明",
    "17‧承租中的房屋",
    "18‧公告為空屋卻有人居住",
    "19‧空屋但得標後馬上出現占有",
    "20‧缺乏經驗：涉及到《高專業性》與《高技術性》併行且《牽涉法令繁雜》的『拍賣屋』不僅需要不斷研究相關法令更需有豐富的經驗累積，例如投標錯誤、點交不順",
    "21‧分身乏力、 所付心力不成比例",
    "22‧專業法令與專業實務多如牛毛：法拍屋、金拍屋等拍賣房屋涉及專業法令與專業實務深廣繁雜多如牛毛",
    "23‧專業能力不足：缺乏專業例如分析能力、專業背景",
    "24‧執行效率不彰：各項程序無法專精，錯誤百出至無法彌補",
    "25‧無配合廠商折扣優惠：缺乏合作廠商長期配合之各項折扣優惠",
    "26‧多花冤枉錢：（管理費、停車費、各項節稅）",
    "27‧債權人或前屋主或前承租人之騷擾：(如設定抵押權人為地下錢莊)",
    "28‧更大金錢損失或無法收尾：想以自行投標來省錢，反而因專業不足而造成更多的金錢損失，或因無法收尾而造成更大的糾紛",
  ];

  return (
    <Container maxWidth="sm">
      <Box>
        <Grid className={classes.gridbox}>
          <Typography variant="h4" style={{ paddingTop: "50px" }}>
            投資比較
          </Typography>
          <Typography variant="h4">投資實例</Typography>
          <Typography
            variant="h4"
            style={{ color: theme.palette.secondary.light }}
          >
            自行投標之陷阱與風險
          </Typography>
          <Typography variant="body1" style={{ marginBottom: "50px" }}>
            在講求專業分工的現代社會中，【一個人能把一份工作或事業做好已相當不容易】，更何況涉及到《高專業性》與《高技術性》併行且《牽涉法令繁雜》的『拍賣屋』呢？
          </Typography>
          <Typography variant="body1">
            正所謂隔行如隔山，術業有專攻；法拍屋、金拍屋所突顯的專業與實務更是無庸置疑!
          </Typography>
          <Typography variant="body1" style={{ marginBottom: "50px" }}>
            【富屋法拍】只從事『法拍』，不兼營房屋仲介，是您標購法拍屋最強大的靠山。
          </Typography>
          {ruleList.map((item) => {
            return <Typography variant="body1">{item}</Typography>;
          })}
        </Grid>
      </Box>
    </Container>
  );
}

function InvestmentForm() {
  const isTable = useMediaQuery("(max-width:960px)");
  const isPhone = useMediaQuery("(max-width:600px)");
  const useStyles = makeStyles((theme) => ({
    root: {
      "& .MuiListItem-root.Mui-selected:hover": {},
      "& .MuiSelect-selectMenu": {
        backgroundColor: "#fff",
      },
      "& .Mui-focused": {
        border: "none" + " !important",
        outline: "none" + " !important",
      },
    },
    formGrid: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      "& .MuiFormLabel-root": {
        // fontSize:'14px'+ ' !important',
      },
    },
  }));

  const classes = useStyles();
  const theme = useTheme();
  const { handleSubmit, control } = useForm({
    defaultValues: {
      fullName: "",
      lineId: "",
      mobile: "",
      financialManagement: "",
      remark: "",
      vcode: "",
    },
  });
  const Alert = useAlert();
  const [saveCustomer, { loading: saveCustomerLoading }] = useMutation(
    SAVE_CUSTOMER,
    {
      onCompleted({ saveCustomer }) {
        if (saveCustomer) {
          window.location.reload();
          return Alert.notice("送出成功");
        }
      },
      onError(error) {
        return Alert.notice(`${error}`);
      },
    }
  );
  function _submit(data) {
    const customerInput = {
      customerType: "SERVICE_AREA",
      source: "NETWORK",
      assignStatus: "WAITING_TO_CONTACT",
      remark: `我要理財=>理財金額：${data.financialManagement}${
        data.remark !== "" ? "，備註：" + data.remark : ""
      }`,
      customerInfo: [
        {
          fullName: data.fullName,
          mobile1: data.mobile,
          line: data.lineId,
        },
      ],
      frontSite: true,
    };

    saveCustomer({ variables: { customerInput } });
  }
  const [financialManagementValue, setFinancialManagementValue] =
    React.useState("");

  return (
    <Container maxWidth="md" style={{ height: "100%" }}>
      <LoadingModal loading={saveCustomerLoading} />
      <Box py={4} className={classes.formGrid}>
        {/* form area */}
        <Grid container>
          {/* title */}
          <Grid xs={12} item>
            <Box>
              <Typography
                variant={isTable ? "h4" : "h2"}
                align="center"
                style={{
                  fontWeight: 700,
                  color: theme.palette.secondary.light,
                }}
              >
                我要理財
              </Typography>
            </Box>
          </Grid>
          {/* title area end */}
          {/* form */}
          <Grid
            container
            xs={12}
            justify={isPhone ? "space-between" : "flex-start"}
            spacing={2}
          >
            {/* ANCHOR 姓名 */}
            <Grid item md={4} xs={6}>
              <Controller
                name="fullName"
                control={control}
                rules={{
                  required: "請輸入姓名",
                }}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography
                      variant="body2"
                      gutterBottom
                      style={{ color: "#616161" }}
                    >
                      姓名
                    </Typography>

                    <TextField
                      placeholder="姓名"
                      {...field}
                      error={error}
                      helperText={error && error.message}
                      fullWidth
                    />
                  </>
                )}
              />
            </Grid>
            {/* ANCHOR Line 帳號 */}
            <Grid item md={4} xs={6}>
              <Controller
                name="lineId"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography
                      variant="body2"
                      gutterBottom
                      style={{ color: "#616161" }}
                    >
                      Line帳號
                    </Typography>
                    <TextField
                      // label="Line帳號"
                      placeholder="Line帳號"
                      {...field}
                      fullWidth
                    />
                  </>
                )}
              />
            </Grid>
            {/* ANCHOR 電話 */}
            <Grid item md={4} xs={12}>
              <Controller
                name="mobile"
                control={control}
                rules={{
                  required: "請輸入電話",
                  pattern: {
                    // value: MobilePattern,
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography
                      variant="body2"
                      gutterBottom
                      style={{ color: "#616161" }}
                    >
                      電話
                    </Typography>
                    <TextField
                      placeholder="電話"
                      {...field}
                      error={error}
                      helperText={error && error.message}
                      fullWidth
                    />
                  </>
                )}
              />
            </Grid>
            {/* ANCHOR 理財金額 */}
            <Grid item md={4} xs={6}>
              <Controller
                control={control}
                name="financialManagement"
                rules={{
                  required: "理財金額為必填選項",
                }}
                render={({
                  field: { onChange, ...otherField },
                  fieldState: { error },
                }) => (
                  <FormControl
                    size="small"
                    variant="outlined"
                    fullWidth
                    error={error}
                  >
                    <Typography
                      variant="body2"
                      gutterBottom
                      style={{ color: "#616161" }}
                    >
                      理財金額
                    </Typography>
                    <Select
                      {...otherField}
                      value={financialManagementValue}
                      displayEmpty
                      onChange={(event) => {
                        setFinancialManagementValue(event.target.value);
                        onChange(event);
                      }}
                      renderValue={
                        financialManagementValue === ""
                          ? () => (
                              <Typography style={{ color: "#9E9E9E" }}>
                                請選擇金額
                              </Typography>
                            )
                          : undefined
                      }
                    >
                      <MenuItem value="20萬以下">20萬以下</MenuItem>
                      <MenuItem value="20萬~100萬">20萬~100萬</MenuItem>
                      <MenuItem value="100萬~500萬">100萬~500萬</MenuItem>
                      <MenuItem value="500萬以上">500萬以上</MenuItem>
                    </Select>
                    <FormHelperText style={{ bottom: "-30%" }}>
                      {error && error.message}
                    </FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
            {/* ANCHOR 備註 */}
            <Grid item xs={12}>
              <Controller
                name="remark"
                control={control}
                rules={{
                  required: false,
                }}
                render={({ field, fieldState: { error } }) => (
                  <FormControl
                    size="small"
                    variant="outlined"
                    error={error}
                    fullWidth
                  >
                    <Typography
                      variant="body2"
                      gutterBottom
                      style={{ color: "#616161" }}
                    >
                      備註
                    </Typography>
                    <TextareaAutosize
                      {...field}
                      error={error}
                      fullWidth
                      placeholder="備註"
                      style={{
                        resize: "none",
                        height: "120px",
                        fontSize: "1em",
                        padding: "10px",
                      }}
                    />
                    <FormHelperText style={{ bottom: "-30%" }}>
                      {error && error.message}
                    </FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
            <Grid item md={5} xs={3}>
              <Controller
                name="vcode"
                control={control}
                rules={{
                  validate: (v) => {
                    if (v !== localStorage.getItem("@fullhouseVcode"))
                      return "驗證碼錯誤";
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography variant="body2">驗證碼</Typography>
                    <Grid container item spacing={1} direction="row">
                      <Grid item>
                        <TextField
                          {...field}
                          error={error}
                          helperText={error && error.message}
                          fullWidth
                          size="small"
                        />
                      </Grid>
                      <Grid item style={{ marginTop: "10px" }}>
                        <VerificationCode />
                      </Grid>
                    </Grid>
                  </>
                )}
              />
            </Grid>
          </Grid>
          {/* form area end */}
        </Grid>
        {/* button */}

        <Box mt="auto" display="flex" justifyContent="center">
          <Button
            variant="contained"
            onClick={handleSubmit(_submit)}
            fullWidth
            style={{
              color: "#fff",
              backgroundColor: theme.palette.secondary.light,
              borderRadius: "40px",
              height: "50px",
              marginTop: "50px",
              width: isTable ? "100%" : "30%",
            }}
          >
            送出
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
